/**
 * The character sheet routes of Phase 2c (CS r6a deliverable 183; DECISIONS 213 ruling 5), owner
 * 2.I, stage `s2b`, since `exit-2c`, frozen: a parallel read, list and update beside 1.AA's and
 * 1.AC-1's stat block routes, which keep `ActorSheetV1`. A route of one kind naming a sheet of the
 * other answers 409 `wrong_kind` with `details.kind`. A stale `baseVersion` answers 409
 * `row_conflict`; a revert path no applied import holds, or data the rows refuse, 422
 * `invalid_body`.
 */
import { DocIdParams } from '../dto/documents.js';
import { listOf } from '../dto/list.js';
import { SheetIdParams, SheetParams } from '../dto/reference.js';
import { CharacterSheetUpdateV1, CharacterSheetV1 } from '../dto/sheets-character.js';
import { defineRoute } from '../route/define-route.js';
import { EXAMPLE_IDS } from './example-ids.js';
import { EXAMPLE_CHARACTER_SHEET, EXAMPLE_CHARACTER_SHEET_REVERTED } from './examples-foundry.js';
const ids = EXAMPLE_IDS;
const sheets2c = {
    auth: 'session',
    status: 'frozen',
    since: 'exit-2c',
    owner: '2.I',
    stage: 's2b',
};
/** One character sheet by its id (the PC sheet of 2.H, the character card). */
export const sheetsCharacterGet = defineRoute({
    id: 'sheets.character.get',
    method: 'GET',
    path: '/api/sheets/:sheetId/character',
    params: SheetIdParams,
    response: { kind: 'json', schema: CharacterSheetV1 },
    errors: { 409: ['wrong_kind'] },
    reference: 'read',
    ...sheets2c,
    examples: {
        request: { params: { sheetId: ids.sheetTamsinReed.id } },
        response: EXAMPLE_CHARACTER_SHEET,
    },
});
/** One document's character sheets (a bounded list), the primary first. */
export const sheetsCharacterList = defineRoute({
    id: 'sheets.character.list',
    method: 'GET',
    path: '/api/docs/:id/character-sheets',
    params: DocIdParams,
    response: { kind: 'json', schema: listOf(CharacterSheetV1) },
    reference: 'read',
    docIds: { owner: ['params.id'] },
    ...sheets2c,
    examples: {
        request: { params: { id: ids.pcTamsinReed.id } },
        response: { items: [EXAMPLE_CHARACTER_SHEET], next: null },
    },
});
/** Edit a character sheet, or revert paths to the latest applied import's values. */
export const sheetsCharacterUpdate = defineRoute({
    id: 'sheets.character.update',
    method: 'PUT',
    path: '/api/docs/:id/sheets/:sheetId/character',
    params: SheetParams,
    body: CharacterSheetUpdateV1,
    response: { kind: 'json', schema: CharacterSheetV1 },
    // CS r6b appends 409 `document_trashed` (DECISIONS 802.3), as r6c declared it on the card routes.
    errors: { 409: ['row_conflict', 'wrong_kind', 'document_trashed'], 422: ['invalid_body'] },
    reference: 'deny',
    docIds: { owner: ['params.id'] },
    ...sheets2c,
    changeBatch: true,
    examples: {
        request: {
            params: { id: ids.pcTamsinReed.id, sheetId: ids.sheetTamsinReed.id },
            body: { baseVersion: 2, revertPaths: ['hp.max'] },
        },
        response: EXAMPLE_CHARACTER_SHEET_REVERTED,
        consumes: true,
    },
});
//# sourceMappingURL=sheets-character.js.map